// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import qs from 'qs'
import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import apiUrl from './common/Global';
import env from './common/Global';

Vue.prototype.env = env;
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueQuillEditor);
axios.defaults.withCredentials = true;
Vue.prototype.$qs = qs;
Vue.prototype.$http = axios;
Vue.prototype.apiUrl = apiUrl;

axios.defaults.timeout = 50000; // 请求超时
axios.defaults.baseURL = Vue.prototype.env.apiUrl;



// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    if (JSON.parse(sessionStorage.getItem("islogin"))) {
      next();
    } else {
      next({
        path: "/login"//指向为你的登录界面
      });
    }
  } else {
    next();
  }

  // if (to.fullPath === "/login") {
  //   if (JSON.parse(sessionStorage.getItem("islogin"))) {
  //     next({
  //       path: from.fullPath
  //     });
  //   } else {
  //     next();
  //   }
  // }
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js